import React from 'react';
import { Button, Dropdown, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
const LanguageSwitcher = ({ inSidebar = false }) => {
  const { t, i18n } = useTranslation();
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const getCurrentLanguageName = () => {
    switch (i18n.language) {
      case 'fr':
        return 'Français';
      case 'es':
        return 'Español';
      case 'de':
        return 'Deutsch';
      case 'zh':
        return '中文';
      case 'ar':
        return 'العربية';
      case 'en':
      default:
        return 'English';
    }
  };

  const items = [
    {
      key: 'en',
      label: 'English',
      onClick: () => changeLanguage('en'),
    },
    {
      key: 'fr',
      label: 'Français',
      onClick: () => changeLanguage('fr'),
    },
    {
      key: 'es',
      label: 'Español',
      onClick: () => changeLanguage('es'),
    },
    {
      key: 'de',
      label: 'Deutsch',
      onClick: () => changeLanguage('de'),
    },
    {
      key: 'zh',
      label: '中文',
      onClick: () => changeLanguage('zh'),
    },
    {
      key: 'ar',
      label: 'العربية',
      onClick: () => changeLanguage('ar'),
    }
  ];

  if (inSidebar) {
    return (
      <Dropdown
        menu={{ items }}
        placement="topRight"
        arrow
        trigger={['click']}
      >
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          height: '40px', 
          cursor: 'pointer',
          color: 'inherit',
          width: '100%'
        }}>
          <span>{getCurrentLanguageName()}</span>
        </div>
      </Dropdown>
    );
  }

  return (
    <Dropdown
      menu={{ items }}
      placement="bottomRight"
      arrow
      trigger={['click']}
    >
      <Button type="text" icon={<GlobalOutlined />}>
        <Space>
          {getCurrentLanguageName()}
        </Space>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
